export class TranslationsManager {
    static doGetStringByLang(KEY, LANGUAGE = null) {
        if(!TRANSLATION_STRINGS[KEY]) {
            throw new Error(`No such key found in the STRINGS translations: ${KEY}`);
        }
        return TRANSLATION_STRINGS[KEY][LANGUAGE || TranslationsManager.doGetLocaleLang()] || "NOT FOUND";
    }

    static doGetImageByLang(KEY, LANGUAGE = null) {
        if(!TRANSLATION_IMAGES[KEY]) {
            throw new Error(`No such key found in the IMAGES translations: ${KEY}`);
        }
        return TRANSLATION_IMAGES[KEY][LANGUAGE || TranslationsManager.doGetLocaleLang()] || "NOT FOUND";
    }

    static doGetLINKByLang(KEY, LANGUAGE = null) {
        if(!TRANSLATION_LINKS[KEY]) {
            throw new Error(`No such key found in the LINKS translations: ${KEY}`);
        }
        return TRANSLATION_LINKS[KEY][LANGUAGE || TranslationsManager.doGetLocaleLang()] || "/";
    }

    static doGetLocaleLang() {
        try {
            const currentLang = document.querySelector('html').getAttribute('lang');
            return String(currentLang).toUpperCase();
        } catch (e) {
            console.error(e);
            return 'CZ';
        }
    }
}


export const TRANSLATION_STRINGS = {
    SIMILAR_PRODUCTS: {
        EN: "Similar products",
        RO: "Produse similare",
        HU: "Hasonló termékek",
        CS: "Podobné produkty",
        SK: "Podobné produkty",
    },
    RELATED_PRODUCTS: {
        EN: "Related products",
        RO: "Produse asemănătoare",
        HU: "Kapcsolódó termékek",
        CS: "Související produkty",
        SK: "Súvisiace produkty",
    },
    INSTAGRAM_HEADER: {
        EN: "Also visit our Instagram",
        RO: "Vizitați și pagina noastră de Instagram",
        HU: "Látogasson el hozzánk az Instragramon",
        CS: "Navštivte také náš Instagram",
        SK: "Navštívte tiež náš Instagram",
    },
    CUSTOMER_REVIEWS_HEADER: {
        EN: "What customers say about us",
        RO: "Ce spun clienții despre noi",
        HU: "Ügyfeleink véleményei",
        CS: "Co o nás říkají zákazníci",
        SK: "Čo o nás hovoria zákazníci",
    },
    FOOTER_LINK_PHYLOSOPHY: {
        EN: "Company philosophy",   // page in administration
        RO: "Filozofia companiei",  // page in administration
        HU: "Cégkultúra",           // page in administration
        CS: "Firemní filozofie",    // page in administration
        SK: "Firemná filozofia",    // page in administration
    },
    FOOTER_LINK_PHYLOSOPHY_URL: {
        EN: "/company-philosophy/", // page in administration
        RO: "/filozofia-companiei/", // page in administration
        HU: "/cegkultura/",         // page in administration
        CS: "/firemni-filozofie/", // page in administration
        SK: "/firemna-filozofia/", // page in administration
    },
    FOOTER_LINK_PRIVACY_SAFETY: {
        EN: "Privacy policy", // page in administration
        RO: "Politica de confidențialitate", // page in administration
        HU: "Személyes adatok védelmének alapelvei", // page in administration
        CS: "Zásady ochrany osobních údajů", // page in administration
        SK: "Zásady ochrany osobných údajov", // page in administration
    },
    FOOTER_LINK_PRIVACY_SAFETY_URL: {
        EN: "/privacy-policy/", // page in administration
        RO: "/politica-de-confidențialitate/", // page in administration
        HU: "/szemelyes-adatok-vedelmenek-alapelvei/",// page in administration
        CS: "/ochrana-osobnich-udaju/",         // page in administration
        SK: "/zasady-ochrany-osobnych-udajov/", // page in administration
    },
    FOOTER_LINK_COOKIES: {
        EN: "Use of cookies and their settings", // page in administration
        RO: "Folosirea de cookies și setările acestora", //page in administration
        HU: "Sütik használata és beállítása", //page in administration
        CS: "Používání cookies a jejich nastavení", // page in administration
        SK: "Používanie cookies a ich nastavenie", // page in administration
    },
    FOOTER_LINK_COOKIES_URL: {
        EN: "/use-of-cookies-and-their-settings/", // page in administration
        RO: "/folosirea-de-cookies-și-setările-acestora/", //page in administration
        HU: "/sütik-használata-és-beállítása", //page in administration
        CS: "/pouzivani-cookies-a-jejich-nastaveni/", // page in administration
        SK: "/pouzivanie-cookies-a-ich-nastavenie/", // page in administration
    },
    FOOTER_FOR_CUSTOMERS: {
        EN: "For customers",
        RO: "Pentru clienți",
        HU: "Ügyfelek számára",
        CS: "Pro zákazníky",
        SK: "Pre zákazníkov",
    },
    FOOTER_EDIT_FV_STUDIO: {
        EN: "Edited by",
        RO: "Editat de",
        HU: "Megváltoztatta",
        CS: "Upravilo",
        SK: "Upravilo",
    },
    NEWSLETTER_REGISTER: {
        EN: "Subscribe to newsletter",
        RO: "Abonare la primirea de noutăți",
        HU: "Feliratkozás a hírlevélre",
        CS: "Přihlášení k odběru novinek",
        SK: "Prihlásenie k odberu noviniek",
    },
    ADVANTAGE_HEADER: {
        EN: "Guarantees",
        RO: "Vă garantăm",
        HU: "Garantáljuk",
        CS: "Garantujeme Vám",
        SK: "Garantujeme vám",
    },
    FILTER_COLOR: {
        EN: "Color", // filter title
        RO: "Culoare", // filter title
        HU: "Szín", // filter title
        CS: "Barva", // filter title
        SK: "Farba", // filter title
    },
    FILTER_VELIKOST: {
        EN: "Size", // filter title
        RO: "Mărime", // filter title
        HU: "Nagyság",// filter title
        CS: "Velikost", // filter title
        SK: "Veľkosť", // filter title
    },
    REGISTRATION_URL: {
        EN: "/registration/", // page
        RO: "/înregistrare/",  // page
        HU: "/regisztráció/",  // page
        CS: "/registrace/", // page
        SK: "/registracia/", // page
    },
    REGISTRATION_TITLE: {
        EN: "New registration",
        RO: "Înregistrare nouă",
        HU: "Új regisztráció",
        CS: "Nová registrace",
        SK: "Nová registrácia",
    },
    MORE_ITEMS_BTN: {
        EN: "More items",
        RO: "MAI MULTE ARTICOLE",
        HU: "TÖBB TÉTEL",
        CS: "VÍCE POLOŽEK",
        SK: "VIAC POLOŽIEK",
    },
    CLIENT_PAGE_MY_ACCOUNT: {
        EN: "My account", // klient page
        RO: "Contul meu", // klient page
        HU: "Az én fiókom", // klient page
        CS: "Můj účet", // klient page
        SK: "Môj účet", // klient page
    },
    CLIENT_PAGE_MY_DETAILS: {
        EN: "My details", // klient page
        RO: "Date personale", // klient page
        HU: "Személyes adatok", // klient page
        CS: "Osobní údaje", // klient page
        SK: "Osobné údaje", // klient page
    },
    CLIENT_PAGE_MY_ORDERS: {
        EN: "Orders", // klient page
        RO: "Comenzi",  // klient page
        HU: "Megrendelések",  // klient page
        CS: "Objednávky", // klient page
        SK: "Objednávky", // klient page
    },
    CLIENT_PAGE_MY_CARDS: {
        EN: "Documents", // klient page
        RO: "Documente", // klient page
        HU: "Dokumentumok", // klient page
        CS: "Doklady", // klient page
        SK: "Doklady", // klient page
    },
    CLIENT_PAGE_MY_DISCOUNTS: {
        EN: "Discounts", // klient page
        RO: "Reduceri",
        HU: "Kedvezmények",
        CS: "Slevy", // klient page
        SK: "Zľavy", // klient page
    },
    CLIENT_PAGE_MY_PRODUCT_RATING: {
        EN: "Product ratings", // klient page
        RO: "Evaluare produs", // klient page
        HU: "Termék értékelés", // klient page
        CS: "Hodnocení produktů", // klient page
        SK: "Hodnotenie produktov", // klient page
    },
    CLIENT_PAGE_MY_DISCUSSION: {
        EN: "Discussion", // klient page
        RO: "Discuții",  // klient page
        HU: "Vita",  // klient page
        CS: "Diskuze", // klient page
        SK: "Diskusia", // klient page
    },
    MORE_BTN: {
        EN: "More",
        RO: "Mai multe",
        HU: "Több",
        CS: "Více",
        SK: "Viac",
    },
    IN_BASKET_BTN: {
        EN: "Add to cart",
        RO: "Adaugă în coș",
        HU: "Kosárba",
        CS: "Do košíku",
        SK: "Do košíka",
    },
    SIZE_CHART: {
        EN: "size chart",
        RO: "tabel dimensiuni",
        HU: "mérettáblázat",
        CS: "tabulka velikostí",
        SK: "tabuľka veľkostí",
    },
    FOR_MORE_INFORMATION: {
        EN: "For more information",
        RO: "Pentru mai multe informații",
        HU: "Több információért",
        CS: "Pro více info",
        SK: "Pre viac info",
    },
    CONTINUE_SHOPPING: {
        EN: "Continue shopping",
        RO: "Continuă cumpărăturile",
        HU: "Vásárlás folytatása",
        CS: "Pokračovat v nákupu",
        SK: "Pokračovať v nákupe",
    },
    LOGIN_BTN: {
        EN: "Login",
        RO: "Logare",
        HU: "Belépés",
        CS: "Přihlášení",
        SK: "Prihlásenie",
    },
    NEWSLETTER_MSG: {
        EN: "Neposielame žiadne zbytočné emaily. Popis aký novinky budeme zasielať a uistenie, že nebudeme poskytovať údaje nikomu ďalšiemu.",
        RO: "Neposielame žiadne zbytočné emaily. Popis aký novinky budeme zasielať a uistenie, že nebudeme poskytovať údaje nikomu ďalšiemu.",
        HU: "Neposielame žiadne zbytočné emaily. Popis aký novinky budeme zasielať a uistenie, že nebudeme poskytovať údaje nikomu ďalšiemu.",
        CS: "Neposíláme žádný zbytečně emaily. Popis jaký novinky budeme zasílat a ujištění, že nebude poskytovat údaje nikomu dalšímu.",
        SK: "Neposielame žiadne zbytočné emaily. Popis aký novinky budeme zasielať a uistenie, že nebudeme poskytovať údaje nikomu ďalšiemu.",
    },
    SIZE_FROM: {
        EN: "From",
        RO: "De la",
        HU: "Tól től",
        CS: "Od",
        SK: "Od",
    },
    SIZE_TO: {
        EN: "To",
        RO: "La",
        HU: "Nak nek",
        CS: "Do",
        SK: "Do",
    },
    FLAG_DOMAIN: {
        EN: "eu",
        RO: "ro",
        HU: "hu",
        CS: "cs",
        SK: "sk",
    }
}
export const TRANSLATION_LINKS = {
    SEARCH: {
        EN: "/search/",
        RO: "/cautare/",
        HU: "/kereses/",
        CS: "/vyhledavani/",
        SK: "/vyhledavani/",
    },
    FACEBOOK: {
        EN: "https://www.facebook.com/utopywear",
        RO: "https://www.facebook.com/utopywear",
        HU: "https://www.facebook.com/utopywear",
        CS: "https://www.facebook.com/utopywear",
        SK: "https://www.facebook.com/utopywearsk",
    },
    INSTAGRAM: {
        EN: "https://www.instagram.com/utopywear",
        RO: "https://www.instagram.com/utopywear",
        HU: "https://www.instagram.com/utopywear",
        CS: "https://www.instagram.com/utopywear",
        SK: "https://www.instagram.com/utopywear_sk",
    }
}
export const TRANSLATION_IMAGES = {}
